import React, { createContext, PropsWithChildren, useCallback, useState } from 'react';
import { InternalApiCaseStatus } from '../../api-internal';

export const CasePendingStatusContext = createContext<
  | {
      pendingStatus: InternalApiCaseStatus | undefined;
      setPendingStatus: (code: InternalApiCaseStatus) => void;
      clearPendingStatus: () => void;
    }
  | undefined
>(undefined);

export const CasePendingStatusProvider = ({ children }: PropsWithChildren) => {
  const [pendingStatus, setPendingStatus] = useState<InternalApiCaseStatus>();

  const clearPendingStatus = useCallback(() => setPendingStatus(undefined), []);

  return (
    <CasePendingStatusContext.Provider value={{ pendingStatus, setPendingStatus, clearPendingStatus }}>
      {children}
    </CasePendingStatusContext.Provider>
  );
};
